import { useCallback, useMemo } from 'react';

import { useCss } from 'craft/hooks';
import { CssSelectorId } from 'craft/types';

const defaultCssProps = { borderRadius: '2px', borderWidth: '1px' };

export const useBorderCss = (nodeIds: string[], cssSelectorId?: CssSelectorId) => {
  const { css = {}, setCss, stylesHierarchy } = useCss(nodeIds, { cssSelectorId });

  const hasBorderInStyleguide =
    typeof stylesHierarchy?.border?.fallbackValue !== 'undefined' ||
    typeof stylesHierarchy?.borderWidth?.fallbackValue !== 'undefined' ||
    typeof stylesHierarchy?.borderRadius?.fallbackValue !== 'undefined';
  const hasBorder = useMemo(() => {
    return (
      css.border !== 'initial' &&
      !!Object.keys(defaultCssProps).find((key) => css[key] && css[key] !== 'initial')
    );
  }, [css]);

  const toggleBorder = useCallback(() => {
    let borderReset = {};
    if (hasBorderInStyleguide) {
      borderReset = hasBorder
        ? { border: 'initial', borderRadius: undefined, borderWidth: undefined }
        : {
            border: stylesHierarchy?.border?.fallbackValue,
            borderRadius: stylesHierarchy?.borderRadius?.fallbackValue,
            borderWidth: stylesHierarchy?.borderWidth?.fallbackValue,
          };
    }
    setCss({
      borderRadius: hasBorder ? undefined : defaultCssProps.borderRadius,
      borderWidth: hasBorder ? undefined : defaultCssProps.borderWidth,
      ...borderReset,
      borderColor: undefined,
      borderStyle: undefined,
    });
  }, [css, setCss, hasBorder]);

  return { css, setCss, hasBorder, toggleBorder, stylesHierarchy };
};
